import {consentCookieName} from "./constants.ts";
import {defaultCookieConsent} from "./default-cookie-consent.ts";
import {parseConsentCookie} from "./parse-consent-cookie.ts";
import {readCookie} from "./read-cookie.ts";
import type {CookieCategory} from "./types.ts";

/**
 * Retrieves the user's consented cookie categories from the consent cookie.
 *
 * @returns A map of cookie categories to boolean values indicating whether
 * the user has consented to each category.
 */
export const getConsentCookieCategories = (): ReadonlyMap<
    CookieCategory,
    boolean
> => {
    const consentCookie = readCookie(consentCookieName);
    const categories = consentCookie
        ? parseConsentCookie(consentCookie)
        : defaultCookieConsent();

    return categories;
};
